<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/brand.html')">系统设置</div></el-breadcrumb-item>
            <el-breadcrumb-item>行业模板数据</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="btns">
            <el-button type="primary" size="small" @click="add" v-auth="['admin/industry.templateItem/add']">添加行业模板数据</el-button>
            <el-button type="danger" size="small" @click="delAll" v-auth="['admin/industry.templateItem/delete']">批量删除</el-button>
        </div>
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column  label="所属行业" align="center">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;" v-if="scope.row.industry">
                        {{scope.row.industry.name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column  label="模板名称" align="center">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;" v-if="scope.row.industrytemplate">
                        {{scope.row.industrytemplate.name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="item_key" label="参数名称"></el-table-column>
            <el-table-column prop="dataType" label="数据类型">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;" v-if="scope.row.data_type == 1">
                        文本
                    </div>
                    <div style="display: flex; align-items: center;" v-if="scope.row.data_type == 2">
                        日期
                    </div>
                    <div style="display: flex; align-items: center;" v-if="scope.row.data_type == 3">
                        日期+时间
                    </div>
                    <div style="display: flex; align-items: center;" v-if="scope.row.data_type == 4">
                        图片
                    </div>
                    <div style="display: flex; align-items: center;" v-if="scope.row.data_type == 5">
                        附件
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="sort_order" label="排序号"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/industry.templateItem/edit']">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['admin/industry.templateItem/delete']">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [],
                isLoad: false,
                pageSize: 20,
                total: 0,
                page: 1,
                number: 0,
            }
        },
        created() {
            this.loadList()
        },
        methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url
				});
				window.open(link.href, '_blank')
			},
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/industry.templateItem/list', {
                    page: this.page,
                    limit: this.pageSize
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.list.data
                        // 页数 page
                        this.total = res.data.list.total

                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 跳转到edit添加
            add() {
                this.$router.push({path: '/TradeTemplateData/edit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id) {
                this.$router.push({
                    path: '/TradeTemplateData/edit.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/industry.templateItem/delete', {
                    data: {
                        ids: id
                    }
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/industry.templateItem/delete', {
                    data: {
                        ids: id
                    }
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            sizeReload(val) {
                this.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            }
        }
    }
</script>
<style scoped>
</style>
